module.exports = __webpack_public_path__ + "img/img1.8f47f343.png";